export function validatePassword(password: string): boolean {
    // Password must be at least 8 characters long and contain a mix of letters and numbers. It may also include special characters.
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&.]{8,}$/;
    return re.test(String(password));
}
